import React, {Component} from "react";
import {Button, Card, CardDeck, Modal} from "react-bootstrap";
import {withRouter} from "react-router-dom";
import Security from "../components/security";
import img from '../static/img';
import {getRoute} from "../breadcrumb/utils";
import screens from "../screens";
import IframeResizer from "iframe-resizer-react";
import {Post} from "../components/request";

class Desktop extends Component {

    async save() {
        if (await Post(`/v1/security/RGPD`)) {
            window.location.href = window.origin + process.env.APP_ROOT;
        }
    }

    spaces(sm, md, lg, xl) {

        let result = [];

        for (let i = sm; i % 2 !== 0; i++) {
            result.push(<div key={Math.random()}
                             style={{margin: "0 15px", flex: "1 0", border: "1px solid transparent"}}
                             className="d-none d-sm-flex d-md-none d-lg-none d-xl-none"/>);
        }

        for (let i = md; i % 3 !== 0; i++) {
            result.push(<div key={Math.random()}
                             style={{margin: "0 15px", flex: "1 0", border: "1px solid transparent"}}
                             className="d-none d-sm-none d-md-flex d-lg-none d-xl-none"/>);
        }

        for (let i = lg; i % 6 !== 0; i++) {
            result.push(<div key={Math.random()}
                             style={{margin: "0 15px", flex: "1 0", border: "1px solid transparent"}}
                             className="d-none d-sm-none d-md-none d-lg-flex d-xl-none"/>);
        }

        for (let i = xl; i % 7 !== 0; i++) {
            result.push(<div key={Math.random()}
                             style={{margin: "0 15px", flex: "1 0", border: "1px solid transparent"}}
                             className="d-none d-sm-none d-md-none d-lg-none d-xl-flex"/>);
        }

        return result;
    }

    render() {
        let app = [
            {
                name: "Mes données",
                onClick: getRoute(screens.Contacts),
                img: img.Contacts
            },
            {
                name: "Mes inscriptions",
                onClick: getRoute(screens.Inscriptions),
                img: img.Inscriptions
            },
            {
                name: "Mes documents",
                onClick: getRoute(screens.Documents),
                img: img.Documents
            },
            {
                name: "Mes absences",
                onClick: getRoute(screens.Absences),
                img: img.Absences
            },
            {
                name: "Valves électroniques",
                onClick: getRoute(screens.Valves),
                img: img.Valves
            }
        ];

        if (process.env.APP_DEPARTEMENT === "ICHEC") {
            app.push({
                name: "Mes commandes",
                onClick: getRoute(screens.Commandes),
                space: {sm: 0, md: 0, lg: 0, xl: 0},
                img: img.Commandes
            });
        }

        app.push({
                name: "Outlook",
                onClick: () => {
                    window.open('https://outlook.office365.com', '_blank');
                },
                space: {sm: 0, md: 0, lg: 0, xl: 0},
                img: img.Mail
            },
            {
                name: "Teams",
                onClick: () => {
                    window.open('msteams://teams.microsoft.com');
                },
                img: img.Teams
            },
            {
                name: "Mon horaire",
                onClick: () => {
                    window.open(`https://horaires.${process.env.APP_DEPARTEMENT}.be`, '_blank');
                },
                img: img.Horaires
            });

        if (process.env.APP_DEPARTEMENT === "ICHEC") {
            app.push({
                    name: "Moodle",
                    onClick: () => {
                        window.open('https://moodle.ichec.be', '_blank');
                    },
                    img: img.Moodle
                },
                {
                    name: "JobTeaser",
                    onClick: () => {
                        window.open('https://ichec.jobteaser.com/');
                    },
                    img: img.JobTeaser
                },
                {
                    name: "Wi-Fi",
                    onClick: () => {
                        window.open('https://www.ichec.be/fr/wi-fi', '_blank');
                    },
                    space: {sm: 0, md: 0, lg: 0, xl: 0},
                    img: img.WiFi
                },
                {
                    name: "Impression",
                    onClick: () => {
                        window.open('https://ichec.eu.uniflowonline.com', '_blank');
                    },
                    space: {sm: 0, md: 0, lg: 0, xl: 0},
                    img: img.MyPrint
                });
        }

        const events = Security.renderEvenements();
        let result = app.slice(0, (process.env.APP_DEPARTEMENT === "ICHEC" ? 6 : 5));
        result.push(...events);
        result.push(...app.slice(process.env.APP_DEPARTEMENT === "ICHEC" ? -7 : -3));

        result.forEach((part, index, array) => {
            if (typeof array[index].onClick === "string") {
                const value = array[index].onClick;
                array[index].onClick = () => {
                    this.props.history.push(value);
                }
            }
        })

        app = result;

        let outlook = app.find(f => f.name === "Outlook").space;
        let numXL = process.env.APP_DEPARTEMENT === "ICHEC" ? 8 : 6;
        let numLG = process.env.APP_DEPARTEMENT === "ICHEC" ? 6 : 7;
        outlook.xl = (events.length > 1) ? (numXL - (events.length)) % numXL : 1 - events.length;
        outlook.lg = (events.length > 0) ? (numLG - (events.length)) % numLG : events.length;

        document.body.classList.add("pace-done");

        let countSM = 0;
        let countMD = 0;
        let countLG = 0;
        let countXL = 0;

        const notifications = Security.getNotifications();
        const notification = notifications.nbDocuments > 0 ? (
            <span className={"notification"}>
                <span>{notifications.nbDocuments}</span>
            </span>
        ) : (<></>);

        const currentUser = Security.getUser();

        if (currentUser.ICHECVerifications === true && currentUser.ICHECAdmin === false && currentUser.ICHECProgrammes === false) {
            setTimeout(() => {
                this.props.history.push(process.env.APP_ROOT);
            }, 500);
        }

        return (
            <>
                <Modal
                    show={currentUser.ICHECAdmin === true || currentUser.ICHECProgrammes === true ? false : !currentUser.isRGPD}
                    size="xl"
                    centered
                    backdrop="static"
                >
                    <Modal.Body>
                        <div style={{height: "90vh", overflowY: "scroll"}}>
                            <IframeResizer
                                src="https://files.ichec.be/ICHEC-Student-Vie-Privee.html"
                                heightCalculationMethod="bodyOffset"
                                inPageLinks
                                style={{
                                    width: "1px",
                                    minWidth: "100%",
                                    minHeight: "100%"
                                }}
                                frameBorder="0"
                            />
                            <div style={{padding: "1rem 1.5rem 2rem"}}>
                                <Button block size="lg" variant={"success"}
                                        onClick={this.save.bind(this)}>J'accepte / I agree</Button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>

                <section>
                    <CardDeck className={"desktop"}>
                        {app.map(function (a, key) {

                            const customSpaces = function (length, type) {
                                if (length > 0) {
                                    let result = [];

                                    for (let i = length; i > 0; i--) {
                                        result.push(<div
                                            key={Math.random()}
                                            style={{margin: "0 15px", flex: "1 0", border: "1px solid transparent"}}
                                            className={`d-none d-sm-none d-md-none d-lg-none d-xl-none d-${type}-flex`}/>);

                                        switch (type) {
                                            case 'sm':
                                                countSM++;
                                                break;
                                            case 'md':
                                                countMD++;
                                                break;
                                            case 'lg':
                                                countLG++;
                                                break;
                                            case 'xl':
                                                countXL++;
                                                break;
                                            default:
                                                break;
                                        }

                                        result.push(jump(type));
                                    }

                                    return result;
                                }
                            }

                            const jump = function (type) {
                                let result = [];

                                switch (type) {
                                    case 'sm':
                                        if (countSM !== 0 && countSM % 2 === 0) {
                                            result.push(<div
                                                key={Math.random()}
                                                className="w-100 my-2 d-none d-sm-block d-md-none d-lg-none d-xl-none"/>);
                                        }
                                        break;
                                    case 'md':
                                        if (countMD !== 0 && countMD % 3 === 0) {
                                            result.push(<div
                                                key={Math.random()}
                                                className="w-100 my-2 d-none d-sm-none d-md-block d-lg-none d-xl-none"/>)
                                        }
                                        break;
                                    case 'lg':
                                        if (countLG !== 0 && countLG % 6 === 0) {
                                            result.push(<div
                                                key={Math.random()}
                                                className="w-100 my-2 d-none d-sm-none d-md-none d-lg-block d-xl-none"/>)
                                        }
                                        break;
                                    case 'xl':
                                        if (countXL !== 0 && countXL % 7 === 0) {
                                            result.push(<div
                                                key={Math.random()}
                                                className="w-100 my-2 d-none d-sm-none d-md-none d-lg-none d-xl-block"/>)
                                        }
                                        break;
                                    default:
                                        break;
                                }

                                return result;
                            }

                            const update = function () {
                                countSM++;
                                countMD++;
                                countLG++;
                                countXL++;
                            }

                            return <React.Fragment key={Math.random()}>
                                {a.space &&
                                    <>
                                        {customSpaces(a.space.sm, 'sm')}
                                        {customSpaces(a.space.md, 'md')}
                                        {customSpaces(a.space.lg, 'lg')}
                                        {customSpaces(a.space.xl, 'xl')}
                                    </>}
                                <Card border={"primary"} onClick={a.onClick} key={key}>
                                    <Card.Body className={"text-center"}>
                                        {a.name === "Mes documents" && <>{notification}</>}
                                        {a.img && <Card.Img src={a.img}/>}
                                        <Card.Text className={"my-3"}>{a.name}</Card.Text>
                                    </Card.Body>
                                </Card>

                                {update()}
                                {jump('sm')}
                                {jump('md')}
                                {jump('lg')}
                                {jump('xl')}

                            </React.Fragment>
                        })}

                        {this.spaces(countSM, countMD, countLG, countXL)}

                    </CardDeck>
                </section>

            </>
        );
    }
}

export default withRouter(Desktop);